import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentPhaseChange } from '../../models/documentPhaseChange';
import { DocumentFormattedFile } from '../../models/DocumentFormattedFile';
import { DocumentFormattedFileEdit } from '../../models/DocumentFormattedFileEdit';
import { DocumentService } from '../../services/document.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-update-effective-date-button',
  templateUrl: './update-effective-date-button.component.html',
  styleUrls: ['./update-effective-date-button.component.scss']
})
export class UpdateEffectiveDateButtonComponent implements OnInit {
    @Input() documentNumber!: string;
    @Input() documentVersion!: string; 
    @Input() documentVersionPeriodicReviewCycle? :string ; 
    @Output()  buttonClick = new EventEmitter();
    showupdateEffectiveDateButton:boolean = false;
    updateEffectiveDateButton !:DocumentPhaseChange;
    documentFormattedFile !: DocumentFormattedFile;
    documentFormattedFileEdit !: DocumentFormattedFileEdit;
  
    constructor(private documentService: DocumentService, private messageService: MessageService) { }
  
    ngOnInit(): void {
      this.updateEffectiveDateButton={
        reason: "",
        phase:6
      }
    }

  click(){
      this.buttonClick.emit();
    }
}
